module.exports = __webpack_public_path__ + "img/Carrozziere-MB-056.6fd9ff9b.jpg";